import * as React from 'react';

import { navigateTop } from '../routing/router-utils';
import CheckOutPickupButton from './CheckOutPickupButton';
import QuantityWarning from '../checkout/QuantityWarning';
import OrderPickupMap from './OrderPickupMap';
import PropTypes from 'prop-types';

import styles from '../checkout/Cart.module.css';

const CartHeaderPickup = ({
  dispensaryId,
  dispensaryName,
  flowerGrams=0,
  dispensaryLocation={},
  minOrderPickup,
  closeMenuFn
}) => {

  return (
    <>  
      <div className={styles.cartHeader}>
        Your Order
        <div onClick={() => navigateTop(`/dispensary/${dispensaryId}`)} className={styles.dispensaryName}>
          {dispensaryName}
        </div>
        
        {/* Don't confuse the user with a checkout button on the /placeOrder page */}
        { window.location.pathname.indexOf('placeOrder') === -1 && 
          <CheckOutPickupButton
            dispensaryId={dispensaryId}
            dispensaryName={dispensaryName}
            minOrderPickup={minOrderPickup} 
            closeMenuFn={closeMenuFn} />
        }
        <QuantityWarning gramsInCart={flowerGrams} />
      </div> 

      { dispensaryLocation.street_address &&
        <OrderPickupMap 
          dispensaryId={dispensaryId}
          dispensaryName={dispensaryName} 
          dispensaryLocation={dispensaryLocation}/>
      }
    </>
  )
}

CartHeaderPickup.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string,
  flowerGrams: PropTypes.number.isRequired,
  dispensaryLocation: PropTypes.object,
  minOrderPickup: PropTypes.number.isRequired,
  closeMenuFn: PropTypes.func.isRequired
}            

export default CartHeaderPickup;